import React from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import InfoCard from 'components/Info/InfoCard';
import ResendEmail from 'views/Users/Details/UserDetails/subcomponents/ResendEmail';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import PermissionsElement from 'views/Users/Details/UserDetails/subcomponents/PermissionsElement';
import BillingAccountPermissionsElement from 'views/Users/Details/UserDetails/subcomponents/BillingAccountPermissionsElement';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICorporateProps {
	user: types.users.IExtendedCorpUserDetails;
	isEndUser: boolean;
	isAdmin: boolean;
	isManager: boolean;
	handleEditUserType: () => void;
	handleClickEditPermission: (accountId: string) => void;
	handleClickAddPermission: () => void;
	handleClickAddBillingAccountPermission: () => void;
	canPerformAction: string;
	resendEmail: types.users.IResendEmail;
}

const Corporate = ({
	user,
	isEndUser,
	isAdmin,
	isManager,
	handleEditUserType,
	handleClickEditPermission,
	handleClickAddPermission,
	handleClickAddBillingAccountPermission,
	canPerformAction,
	resendEmail,
}: ICorporateProps) => {
	const classes = useStyles();

	return (
		<GridContainer justify="flex-start">
			<GridItem xs={12} md={6} className={classes.infoCardGrid}>
				<InfoCard
					buttons={[
						{
							label: translate('edit'),
							onClick: handleEditUserType,
						},
					]}
					elements={[
						{
							title: translate('users.details.userType'),
							value: translate(`role.${user.userData.userType}`),
						},
					]}
					title={translate('users.details.userInformation')}
					action={canPerformAction}
					noBorder
					body={
						<ResendEmail
							lastSentActivationEmailDate={user?.userData?.lastSentActivationEmailDate}
							userType={user?.userData?.userType}
							{...resendEmail}
						/>
					}
				/>
			</GridItem>
			<ConditionalRender
				show={!!user && !isEndUser}
				onTrue={() => (
					<PermissionsElement
						isAdmin={isAdmin}
						handleClickAddPermission={handleClickAddPermission}
						handleClickEditPermission={handleClickEditPermission}
						canPerformAction={canPerformAction}
						user={user}
					/>
				)}
			/>
			<ConditionalRender
				show={!!user && isManager}
				onTrue={() => (
					<BillingAccountPermissionsElement
						handleClickAddPermission={handleClickAddBillingAccountPermission}
						canPerformAction={canPerformAction}
						user={user}
					/>
				)}
			/>
		</GridContainer>
	);
};

export default Corporate;
